<template>


  <div id="works-list" class="container">

    <!-- SHOWCODE -->
    <div class="row work right">
      <div v-show="!isMobile" class="col-xs-12 col-sm-12 col-md-5 offset-lg-4 col-lg-2 col-xl-2" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <div class="v-center">
          <router-link :to="{name: 'works-showcode'}">
            <p class="meta">UX, UI &amp; Brand</p>
            <h2>ShowCode.</br>Contests</h2>
          </router-link>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-showcode'}">
          <ts-image :src="ImageShowCode.url" :width="ImageShowCode.size[0]" :height="ImageShowCode.size[1]" :bg-color="ImageShowCode.bgColor"></ts-image>
        </router-link>
      </div>
      <div v-show="isMobile" class="col-xs-12 col-sm-12 col-md-5 offset-lg-4 col-lg-2 col-xl-2" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-showcode'}">
          <p class="meta">UX, UI &amp; Brand</p>
          <h2>ShowCode.</br>Contests</h2>
        </router-link>
      </div>
    </div>

    <!-- THE GLOBALWEBINDEX -->
    <div class="row work left">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
          <router-link :to="{name: 'works-gwi-survey-dashboard'}">
            <ts-image :src="ImageGWI.url" :width="ImageGWI.size[0]" :height="ImageGWI.size[1]" :bg-color="ImageGWI.bgColor"></ts-image>
          </router-link>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
          <div class="v-center">
            <router-link :to="{name: 'works-gwi-survey-dashboard'}">
              <p class="meta">UX, UI &amp; Data Viz</p>
              <h2>The GlobalWebIndex.</br>Audience Insights</h2>
            </router-link>
          </div>
        </div>
    </div>

    <!-- THE COACHING MANUAL -->
    <div class="row work right">
      <div v-show="!isMobile" class="col-xs-12 col-sm-12 col-md-5 offset-lg-4 col-lg-2 col-xl-2" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <div class="v-center">
          <router-link :to="{name: 'works-the-coaching-manual'}">
            <p class="meta">UX &amp; UI</p>
            <h2>The Coaching</br>Manual</h2>
          </router-link>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5"  data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-the-coaching-manual'}">
          <ts-image :src="ImageTCM.url" :width="ImageTCM.size[0]" :height="ImageTCM.size[1]" :bg-color="ImageTCM.bgColor"></ts-image>
        </router-link>
      </div>
      <div v-show="isMobile" class="col-xs-12 col-sm-12 col-md-5 offset-lg-4 col-lg-2 col-xl-2" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-the-coaching-manual'}">
          <p class="meta">UX &amp; UI</p>
          <h2>The Coaching</br>Manual</h2>
        </router-link>
      </div>
    </div>

    <!-- EVOLUTION -->
    <div class="row work left">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-21stclub-evolution'}">
          <ts-image :src="ImageEvolution.url" :width="ImageEvolution.size[0]" :height="ImageEvolution.size[1]" :bg-color="ImageEvolution.bgColor"></ts-image>
        </router-link>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <div class="v-center">
          <router-link :to="{name: 'works-21stclub-evolution'}">
            <p class="meta">UX, UI, &amp; Brand</p>
            <h2>Evolution. Football</br>Club Management</h2>
          </router-link>
        </div>
      </div>
    </div>


    <!-- WIRED MAGAZINE -->
    <div class="row work right">
      <div v-show="!isMobile" class="col-xs-12 col-sm-12 col-md-5 offset-lg-4 col-lg-2 col-xl-2"  data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <div class="v-center">
          <router-link :to="{name: 'works-wired-magazine'}">
            <p class="meta">Data Viz</p>
            <h2>Wired Magazine.</br>Data Viz</h2>
          </router-link>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-wired-magazine'}">
          <ts-image :src="ImageWired.url" :width="ImageWired.size[0]" :height="ImageWired.size[1]" :bg-color="ImageWired.bgColor"></ts-image>
        </router-link>
      </div>
      <div v-show="isMobile" class="col-xs-12 col-sm-12 col-md-5 offset-lg-4 col-lg-2 col-xl-2" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-wired-magazine'}">
          <p class="meta">Data Viz</p>
          <h2>Wired Magazine.</br>Data Viz</h2>
        </router-link>
      </div>
    </div>

    <!-- CHATAMO -->
    <div class="row work left">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
        <router-link :to="{name: 'works-futr-chatamo'}">
          <ts-image :src="ImageChatamo.url" :width="ImageChatamo.size[0]" :height="ImageChatamo.size[1]" :bg-color="ImageChatamo.bgColor"></ts-image>
        </router-link>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5" data-sal="slide-up" data-sal-delay="150" data-sal-duration="600" data-sal-easing="ease">
        <div class="v-center">
          <router-link :to="{name: 'works-futr-chatamo'}">
            <p class="meta">UX, UI, &amp; Brand</p>
            <h2>Chatamo.</br>Bots For Business</h2>
          </router-link>
        </div>
      </div>

    </div>
  </div>

</template>


<script>

import sal from 'sal.js'
import TsImage from '@/components/TSImage.vue'
import Placeholder from "@/assets/images/placeholder-thumb.jpg"

import ImageShowCode from "@/assets/images/works/thumb_showcode.png"
import ImageTCM from "@/assets/images/works/thumb_tcm.png"
import ImageGWI from "@/assets/images/works/thumb_gwi.png"
import ImageWired from "@/assets/images/works/thumb_wired.png"
import ImageEvolution from "@/assets/images/works/thumb_evolution.png"
import ImageChatamo from "@/assets/images/works/thumb_chatamo.png"


export default {

  name: 'TsWorksList',

  data() {
    return {
      window: {
        width: window.innerWidth
      },
      thumbnail: {
        url: Placeholder,
        size: [1208,1208],
        bgColor: "none"
      },
      ImageShowCode: {
        url: ImageShowCode,
        size: [1400,900],
        bgColor: "none",
      },
      ImageTCM: {
        url: ImageTCM,
        size: [1400,900],
        bgColor: "none"
      },
      ImageGWI: {
        url: ImageGWI,
        size: [1400,900],
        bgColor: "none"
      },
      ImageWired: {
        url: ImageWired,
        size: [1400,900],
        bgColor: "none"
      },
      ImageEvolution: {
        url: ImageEvolution,
        size: [1400,900],
        bgColor: "none"
      },
      ImageChatamo: {
        url: ImageChatamo,
        size: [1400,900],
        bgColor: "none"
      }
    }
  },

  computed: {
    isMobile() {
      return this.window.width < 768;
    }
  },

  components: {
    TsImage
  },

  mounted() {
    sal({threshold: 0.10});
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    }
  }
}

</script>
